import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Zap, Cpu, FileText } from "lucide-react";

const heroImage = "/hero-warehouse.webp";

const BrandHero = () => (
  <section className="relative min-h-[600px] flex items-center overflow-hidden">
    <div className="absolute inset-0">
      <img
        src={heroImage}
        alt="Nardy Automation US warehouse — transformer parts and industrial automation components"
        className="w-full h-full object-cover"
        width={1920}
        height={800}
        fetchPriority="high"
        loading="eager"
        decoding="async"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-surface-darker/95 via-surface-darker/85 to-surface-darker/65" />
    </div>

    <div className="container relative z-10 py-20 lg:py-28">
      <div className="max-w-3xl">
        <p className="inline-block text-brand font-display font-semibold uppercase tracking-wider text-xs md:text-sm mb-5 border border-brand/30 px-3 py-1 rounded-full">
          B2B Industrial Supplier · Windermere, FL · Worldwide Shipping
        </p>
        <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-[1.1]">
          Industrial Parts Supplier for Transformers and Automation
        </h1>
        <p className="text-secondary-foreground/85 text-lg md:text-xl mb-10 leading-relaxed max-w-2xl">
          Nardy Automation supplies transformer components and industrial automation parts from US inventory with fast worldwide shipping.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
          <Link to="/transformer-parts">
            <Button
              size="lg"
              className="bg-gradient-brand text-primary-foreground font-semibold text-base px-7 py-6 hover:opacity-90 transition-opacity w-full sm:w-auto"
            >
              <Zap className="w-5 h-5" />
              Explore Transformer Solutions
            </Button>
          </Link>
          <Link to="/industrial-automation-parts">
            <Button
              size="lg"
              variant="outline"
              className="border-brand/50 text-brand hover:bg-brand/10 font-semibold text-base px-7 py-6 w-full sm:w-auto"
            >
              <Cpu className="w-5 h-5" />
              Shop Automation Parts
            </Button>
          </Link>
          <Link to="/request-quote">
            <Button
              size="lg"
              variant="ghost"
              className="text-white hover:bg-white/10 font-semibold text-base px-7 py-6 w-full sm:w-auto"
            >
              <FileText className="w-5 h-5" />
              Request a Quote
            </Button>
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default BrandHero;
